import { Minus, Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faq } from "@/content/siteContent";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export default function Faq() {
  return (
    <section id="faq" className="honeycomb bg-ink py-24 md:py-32" data-testid="faq-section">
      <div className="relative z-10 mx-auto max-w-4xl px-5 md:px-8">
        <SectionHeading
          chapter={faq.chapter}
          microtitle={faq.microtitle}
          titleA={faq.titleA}
          titleB={faq.titleB}
        />

        <Reveal>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="overflow-hidden rounded-2xl border border-metal bg-graphite transition-colors duration-300 data-[state=open]:border-brand/60"
              >
                <AccordionTrigger
                  className="px-6 py-5 text-left font-display text-sm font-bold tracking-wide text-paper transition-colors duration-300 hover:no-underline data-[state=open]:bg-brand data-[state=open]:text-ink md:text-base [&>svg]:hidden [&[data-state=open]_.icon-plus]:hidden [&[data-state=closed]_.icon-minus]:hidden [&[data-state=open]_.faq-num]:text-ink"
                  data-testid={`faq-question-${i + 1}`}
                >
                  <span className="flex items-center gap-4">
                    <span className="faq-num text-xs font-extrabold tracking-[0.16em] text-brand">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {item.q}
                  </span>
                  <span className="ml-4 flex-shrink-0">
                    <Plus className="icon-plus h-5 w-5 text-brand [data-state=open]:text-ink" strokeWidth={2.5} />
                    <Minus className="icon-minus h-5 w-5" strokeWidth={2.5} />
                  </span>
                </AccordionTrigger>
                <AccordionContent className="bg-ink px-6 pb-6 pt-5 text-sm leading-relaxed text-mist" data-testid={`faq-answer-${i + 1}`}>
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
